var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/hooks/useSelectVariables.tsx";
import React, { useEffect, useRef, useState } from 'react';
export const useSelectVariables = ({
  getOptionLabel,
  value
}) => {
  const valueLabel = value ? getOptionLabel(value) : '';
  const [inputValue, setInputValue] = useState(valueLabel || '');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [focusedOptionIdx, setFocusedOptionIdx] = useState(0);
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => {
    if (value) {
      setInputValue(valueLabel);
    } else {
      setInputValue('');
    }
  }, [setInputValue, value, valueLabel]);
  return {
    valueLabel,
    inputValue,
    setInputValue,
    anchorEl,
    setAnchorEl,
    focusedOptionIdx,
    setFocusedOptionIdx,
    focused,
    setFocused,
    inputRef
  };
};